import React, { useEffect } from "react";
import BackendLayout from "../../layouts/BackendLayout";
import { PageTitle } from "../../components/admin";
import { MACHINE_MASTER_EXPORT } from "../../constants/routes";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { useDocumentTitle } from "../../hooks";
import { useDispatch } from "react-redux";
import { getMachineExportPageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import FileExport from "../../components/file-management/FileExport";
import { API_MACHINE_EXPORT_ALL, API_MACHINE_EXPORT_ACTIVE } from "../../constants/api";
import {ButtonExport, RedirectAlert} from "../../components";
import { clearPageLoading, setPageLoading } from "../../store/actions";
import {MACHINE_MASTER_EXPORT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function MachineExportPage() {
  useRedirectPage(MACHINE_MASTER_EXPORT_PAGE);
  useDocumentTitle("設備マスタエクスポート - 点検王");
  const breadcrumb = getRouteBreadcrumb(MACHINE_MASTER_EXPORT);
  const dispatch = useDispatch();

  const setMachineExportPageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings = await getMachineExportPageSettings();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
  };

  useEffect(() => {
    setMachineExportPageSettings();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="設備マスタエクスポート" />
      <RedirectAlert />
      <FileExport
        title="現在の設備マスタの状態をファイル出力します"
        description="設備データをExcelファイルとしてエクスポートするために、以下のボタンを押してください。"
        className="xl:space-x-[80px] lg:space-x-[60px] md:space-x-5"
      >
        <ButtonExport
          buttonColor="yellow"
          iconColor="616161"
          description="無効化した設備を含む"
          borderColor="tenken__border-gray-500"
          descriptionTextColor="text-tenken-gray-900"
          titleTextColor="text-tenken-gray-700"
          apiUrl={API_MACHINE_EXPORT_ALL}
          id="export-all-machine"
        />
        <ButtonExport
          buttonColor="primary"
          iconColor="EEEEEE"
          description="無効化した設備を含まない"
          borderColor="border-[#E0E0E0]"
          descriptionTextColor="text-white"
          titleTextColor="text-[#F5F5F5]"
          apiUrl={API_MACHINE_EXPORT_ACTIVE}
          id="export-machine-active"
        />
      </FileExport>
    </BackendLayout>
  );
}
